if (!customElements.get('zen-product-bundle')) {
  customElements.define('zen-product-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.status = this.querySelector('[data-bundle-status]');
      this.cartLink = this.querySelector('[data-bundle-cart-link]');
      this.items = [...this.querySelectorAll('[data-bundle-item]')];
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency });
      this.form.addEventListener('change', () => this.updatePreview());
      this.form.addEventListener('submit', event => this.addBundle(event));
      this.updatePreview();
    }

    selection() {
      return this.items.map(item => {
        const option = item.querySelector('select').selectedOptions[0];
        return { id: Number(option.value), quantity: Number(item.dataset.quantity), price: Number(option.dataset.price), discount: Number(item.dataset.discount), once: item.dataset.once === 'true', available: option.dataset.available === 'true', element: item };
      });
    }

    updatePreview() {
      let total = 0;
      let regular = 0;
      this.selection().forEach(item => {
        const original = item.price * item.quantity;
        const offered = Math.round(original * (100 - item.discount) / 100);
        regular += original;
        total += offered;
        const price = item.element.querySelector('[data-item-price]');
        if (item.discount !== 100) price.textContent = this.money.format(offered / 100);
        const compare = item.element.querySelector('[data-regular-price]');
        if (compare) compare.textContent = this.money.format(original / 100);
      });
      this.querySelector('[data-bundle-total]').textContent = this.money.format(total / 100);
      const saving = this.querySelector('[data-bundle-saving] span');
      if (saving) saving.textContent = this.money.format((regular - total) / 100);
      this.button.disabled = this.busy || this.button.dataset.configured !== 'true' || !this.items.length || this.selection().some(item => !item.available);
    }

    async request(path, body) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Please review your cart before trying again.');
      return data;
    }

    async addBundle(event) {
      event.preventDefault();
      if (this.busy || this.button.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.status.textContent = 'Adding your bundle…';
      this.status.dataset.error = 'false';
      this.cartLink.hidden = true;
      let added = false;
      try {
        const selection = this.selection();
        const before = await this.request('cart.js');
        const quantities = new Map();
        for (const item of selection) {
          const existing = before.items.filter(line => line.variant_id === item.id && !line.selling_plan_allocation).reduce((sum, line) => sum + line.quantity, 0);
          const pending = quantities.get(item.id) || 0;
          const quantity = item.once ? Math.max(0, item.quantity - existing - pending) : item.quantity;
          quantities.set(item.id, pending + quantity);
        }
        const items = [...quantities].filter(([, quantity]) => quantity > 0).map(([id, quantity]) => ({ id, quantity }));
        if (items.length) {
          await this.request('cart/add.js', { items });
          added = true;
        }
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart?.getSectionsToRender().map(section => section.id);
        const body = { ...(sections ? { sections, sections_url: window.location.pathname } : {}) };
        if (this.dataset.discountMode === 'code' && this.dataset.discountCode.trim()) {
          const codes = [...(before.discount_codes || []).map(code => code.code), this.dataset.discountCode.trim()];
          body.discount = [...new Set(codes)].join(',');
        }
        const after = Object.keys(body).length ? await this.request('cart/update.js', body) : await this.request('cart.js');
        const discountedItems = selection.filter(item => item.discount > 0);
        const missingDiscount = discountedItems.some(item => {
          const lines = after.items.filter(line => line.variant_id === item.id && !line.selling_plan_allocation);
          const expectedUnit = Math.round(item.price * (100 - item.discount) / 100);
          return lines.filter(line => line.final_price <= expectedUnit).reduce((sum, line) => sum + line.quantity, 0) < item.quantity;
        });
        const codeRejected = this.dataset.discountMode === 'code' && this.dataset.discountCode.trim() && !after.discount_codes?.some(code => code.code.toLowerCase() === this.dataset.discountCode.trim().toLowerCase() && code.applicable);
        this.status.textContent = missingDiscount || codeRejected ? 'The items are in your cart, but the advertised discount was not applied. Please review the cart before checkout.' : 'Your bundle is in the cart. Review your total before checkout.';
        this.status.dataset.error = String(missingDiscount || codeRejected);
        this.cartLink.hidden = false;
        if (cart && sections.every(id => after.sections?.[id])) {
          cart.setActiveElement(this.button);
          cart.classList.remove('is-empty');
          cart.renderContents(after);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zen-product-bundle', cartData: after });
      } catch (error) {
        this.status.textContent = added ? 'The items were added. Please open your cart to check the total before adding again.' : error.message;
        this.status.dataset.error = 'true';
        this.cartLink.hidden = false;
      } finally {
        this.busy = false;
        this.updatePreview();
      }
    }
  });
}
